module.exports = __webpack_public_path__ + "static/thumbnail-53aed9067bd30b9b17775bc539f9fcf5.png";